import { Obj, Arr } from "@kizmann/pico-js";
import AppService from "#pub/service/AppService.js";

export default {

    name: 'AppStatus',

    data()
    {
        return {
            load: true, data: null
        };
    },

    mounted()
    {
        this.fetchStatus();
    },

    methods: {

        fetchStatus()
        {
            let query = {
                panels: 'daily_message,daily_task'
            };

            let config = {
                onLoad: () => this.load = true,
                onDone: () => this.load = false,
            };

            AppService.fetchStatus(config, query)
                .then((res) => {
                    this.data = Obj.get(res.data, 'data', {});
                });
        }
    },

    renderAction()
    {
        let refreshProps = {
            glass: true, icon: 'fa fa-sync'
        };

        refreshProps['onClick'] = () => {
            this.fetchStatus();
        };

        return [
            (<NButton {...refreshProps}>{this.trans('Refresh')}</NButton>)
        ];
    },

    renderHeader()
    {
        let headerProps = {
            title: this.trans('API Status'),
        };

        headerProps['onUpdate:search'] = (value) => {
            this.search = value;
        };

        let slots = {
            action: this.ctor('renderAction')
        };

        return (
            <AppHeader {...headerProps} v-slots={slots} />
        );
    },

    renderBarChart(prop)
    {
        if ( ! Obj.has(this.data, prop) ) {
            return null;
        }

        let items = Arr.each(this.data[prop], (val) => {
            return (<NChartItem color2="auto" {...val} />);
        });

        return (
            <NChartBar size="sm" limit={0} renderLegend={false}>
                { items }
            </NChartBar>
        );
    },

    renderDailyMessage()
    {
        let titleHtml = (
            <div class="app-chart__title">
                <span>{this.trans('Daily messages')}</span>
            </div>
        );

        return (
            <div class="app-chart">
                {[titleHtml, this.ctor('renderBarChart')('daily_message')]}
            </div>
        );
    },

    renderDailyTask()
    {
        let titleHtml = (
            <div class="app-chart__title">
                <span>{this.trans('Daily tasks')}</span>
            </div>
        );

        return (
            <div class="app-chart">
                {[titleHtml, this.ctor('renderBarChart')('daily_task')]}
            </div>
        );
    },

    renderContent()
    {
        return (
            <NScrollbar class="app-content">
                {this.ctor('renderDailyMessage')()}
                {this.ctor('renderDailyTask')()}
            </NScrollbar>
        );
    },

    render: function () {
        return (
            <NLoader class="app-view" visible={this.load}>
                {this.ctor('renderHeader')()}
                {this.ctor('renderContent')()}
            </NLoader>
        );
    }

}